<script>
import {defineComponent} from 'vue'
import {Carousel, Navigation, Pagination, Slide} from 'vue3-carousel'
import axios from "axios";

import 'vue3-carousel/dist/carousel.css'
import {getIsMobile} from "../../../composables/isMobile";

export default defineComponent({
  name: 'services_carousel',
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  async created(){
    await axios.get(`${process.env.VUE_APP_API_URL}slides/`, {
      params: {
        device: getIsMobile() ? 'mobile' : 'desktop'
      }
    })
      .then(response => {
        this.data = response.data;
      });
    this.isLoading = false
  },
  data(){
    return {
      isLoading: true,
      data: null,
    }
  },
  methods: {
    mediaUrl(path) {
      if (path !== "" && path !== undefined) {
        const width = window.innerWidth;
        const height = window.innerHeight;
        const baseUrl = process.env.VUE_APP_API_URL + path;
        return `${baseUrl}?width=${width}&height=${height}`;
      }
      return null;
    },
    stripHtml(html) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || "";
    },
    truncatedDescription(slideDescription) {
      const maxLength = 250;
      let plainText = this.stripHtml(slideDescription);
      if (plainText.length > maxLength) {
        return slideDescription.slice(0, maxLength) + "...";
      }
      return slideDescription;
    }
  },
})
</script>

<template>
  <div class="container">
    <Carousel v-if="!isLoading" :wrap-around="true" :autoplay="3000">
      <Slide v-for="slide in data" :key="slide">
        <div class="carousel__item" :style="{ backgroundImage: `url(${mediaUrl(slide.media_file.file)})` }">
          <p v-if="slide.title" class="slide_title">{{slide.title}}</p>
          <div v-show="slide.description"  class="slide_content"
               v-html="truncatedDescription(slide.description)"></div>
          <a v-if="slide.action_buttons.length >= 1" :href="slide.action_buttons[0]?.link">
            <button class="slide_button" v-if="true">{{ slide.action_buttons[0]?.title }}
            </button></a>
        </div>
      </Slide>

      <template #addons>
        <Navigation/>
        <Pagination/>
      </template>
    </Carousel>
  </div>
</template>

<style scoped>
.carousel{
  width: 100%;
}
.carousel__item {
  visibility: hidden;
}
.carousel__item:first-child {
  visibility: visible;
  height: 60vh;
  width: 100%;
  color: var(--vc-nav-color);
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  background-position: center;
  background-size: cover;
  padding-left: 80px;
  .slide_title{
    font-size: 1.7vw;
  }
  .slide_content{
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    text-align: start;
    max-width: 80%;
    padding: 10px;
    font-size: 1.5vw;
    max-font-size: 16px;
    /* From https://css.glass */
    background: rgba(255, 255, 255, 0.16);
    border-radius: 16px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
  }
  @supports (backdrop-filter: blur(5px)) {
      .slide_content {
          background: rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(5px);
          -webkit-backdrop-filter: blur(5px);
      }
  }
  @media (max-width: 768px) {
    .slide_content {
      max-width: 90%;
      font-size: 25px;
      margin-top: 20px;
    }
    .slide_title{
      font-size: 6vw;
    }
  }
  .slide_button{
    position: absolute;
    right: 80px;
    bottom: 40px;
    padding: 10px 30px;
    box-sizing: border-box;
    border: none;
    border-radius: 5px;
    font-size: 20px;
    background: linear-gradient(180deg,  #68749F 0%, #BE3F43 100%);
    color: white; /* Цвет текста */
    transition: background 0.3s ease;
  }
  .slide_button:hover {
    background: linear-gradient(180deg, #BE3F43 0%, #dca364 100%);
  }
}
@media (max-width: 768px) {
    .carousel__item:first-child {
      padding-left: 0;
      align-items: center;
      font-size: 25px;

      .slide_button{
        position: absolute;
        bottom: 25px;
        right: 40px;
      }
    }
  }

.carousel__slide {
  padding: 10px;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
}
</style>